var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77811 0H1.64384C0.72329 0 0 0.72329 0 1.64384V8.77811C0 9.69866 0.72329 10.4219 1.64384 10.4219H8.77811C9.69866 10.4219 10.4219 9.69866 10.4219 8.77811V1.64384C10.4219 0.756166 9.69866 0 8.77811 0Z",
    fill: "#F0B429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3562 0H15.222C14.3014 0 13.5781 0.72329 13.5781 1.64384V8.77811C13.5781 9.69866 14.3014 10.4219 15.222 10.4219H22.3562C23.2768 10.4219 24.0001 9.69866 24.0001 8.77811V1.64384C24.0001 0.756166 23.2439 0 22.3562 0ZM22.685 8.77811C22.685 8.97537 22.5535 9.10687 22.3562 9.10687H15.222C15.0247 9.10687 14.8932 8.97537 14.8932 8.77811V1.64384C14.8932 1.44658 15.0247 1.31507 15.222 1.31507H22.3562C22.5535 1.31507 22.685 1.44658 22.685 1.64384V8.77811Z",
    fill: "#F0B429"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77811 13.5781H1.64384C0.72329 13.5781 0 14.3014 0 15.222V22.3562C0 23.2768 0.72329 24.0001 1.64384 24.0001H8.77811C9.69866 24.0001 10.4219 23.2768 10.4219 22.3562V15.222C10.4219 14.3014 9.69866 13.5781 8.77811 13.5781Z",
    fill: "#F0B429"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3562 13.5781H15.222C14.3014 13.5781 13.5781 14.3014 13.5781 15.222V22.3562C13.5781 23.2768 14.3014 24.0001 15.222 24.0001H22.3562C23.2768 24.0001 24.0001 23.2768 24.0001 22.3562V15.222C24.0001 14.3014 23.2439 13.5781 22.3562 13.5781Z",
    fill: "#F0B429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.0c98d09018e1c1e2fb8bae3de21480f6.svg";
export { ForwardRef as ReactComponent };